import InvoiceResponse from "../models/serviceApi/InvoiceResponse";
import Invoice from "../models/domain/Invoice";
import ClinicAddress from "../models/domain/ClinicAddress";

export default class InvoiceMapper {
  static mapResponseToModel(response: InvoiceResponse): Invoice {
    return new Invoice(
      response.date,
      response.receiptNo,
      response.appointmentId,
      response.labReportId,
      response.paymentMode,
      response.bankName,
      response.bankBranch,
      response.transactionId,
      response.chequeNo,
      response.cardChequeType,
      response.accountHolder,
      response.invoiceType,
      response.patientId,
      response.patientName,
      response.patientMobile,
      response.patientEmail,
      response.doctorName,
      response.doctorRegNo,
      response.doctorSpeciality,
      response.clinicName,
      new ClinicAddress(
        response.clinicAddress.country,
        response.clinicAddress.zipCode,
        response.clinicAddress.address,
        response.clinicAddress.streetAddress,
        response.clinicAddress.city,
        response.clinicAddress.entityName,
        response.clinicAddress.locality,
        response.clinicAddress.state,
      ),
      response.clinicPhone,
      response.clinicEmail,
      response.consultDescription,
      response.consultInvAmount,
      response.consultInvSGstAmount,
      response.consultInvCGstAmount,
      response.particulars,
      response.discount,
      response.totalAmount,
      response.totalSSGstAmount,
      response.totalCGstAmount,
      response.paidAmount,
      response.pendingAmount,
      response.paymentStatus,
    );
  }
}
